// Single source of truth for Total-E brand copy so wording stays consistent across
// the ecosystem. The brand name "Total-E" is never translated; the slogan is used
// verbatim (hyphen, capitalization, comma and final period all preserved).
export const TOTAL_E_SLOGAN = 'Your Operation, Total-E Connected.';
